import {
  DataWarehouseBigQueryDatabaseHttpModel,
  DataWarehouseDatabaseHttpModel,
  DataWarehouseSnowflakeDatabaseHttpModel,
} from '../models/org-space-http.model';

type DatabaseUrlBuilder<T extends DataWarehouseDatabaseHttpModel> = (database: T) => string;
type BigQueryDatabaseUrlBuilder = DatabaseUrlBuilder<DataWarehouseBigQueryDatabaseHttpModel>;
type SnowflakeDatabaseUrlBuilder = DatabaseUrlBuilder<DataWarehouseSnowflakeDatabaseHttpModel>;

export const buildBigQueryDatabaseUrl: BigQueryDatabaseUrlBuilder = (
  database: DataWarehouseBigQueryDatabaseHttpModel,
): string =>
  `https://console.cloud.google.com/bigquery?project=${database.project_id}&d=${database.name}&p=${database.project_id}&page=dataset`;

export const buildSnowflakeDatabaseUrl: SnowflakeDatabaseUrlBuilder = (
  database: DataWarehouseSnowflakeDatabaseHttpModel,
): string => `https://${database.account}.snowflakecomputing.com/console#/data/tables?databaseName=${database.name}`;
